const FOCUSABLE_SELECTOR = [
  'input:not([type="hidden"]):not([disabled])',
  'textarea:not([disabled])',
  'select:not([disabled])',
  'button:not([disabled])',
  'a[href]',
  '[role="combobox"]',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

const isVisible = (element) =>
  Boolean(
    element &&
      !element.closest('[aria-hidden="true"]') &&
      (element.offsetWidth || element.offsetHeight || element.getClientRects().length)
  );

const isClearControl = (element) =>
  element.matches(
    '.cpClearInputBtn, .clearableIcon, .selectClearIcon, .MuiAutocomplete-clearIndicator'
  ) || Boolean(element.closest('.cpClearInputBtn, .clearableIcon, .selectClearIcon'));

export const focusAdjacentField = (referenceElement, backwards = false) => {
  if (!referenceElement || typeof document === 'undefined') return;

  const scope =
    referenceElement.closest('form') ||
    referenceElement.closest('[role="dialog"]') ||
    referenceElement.closest('.MuiDialog-paper') ||
    document;

  const focusableElements = Array.from(scope.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
    (element, index, elements) =>
      isVisible(element) && !isClearControl(element) && elements.indexOf(element) === index
  );
  const containedIndexes = focusableElements
    .map((element, index) => (referenceElement.contains(element) ? index : -1))
    .filter((index) => index >= 0);

  if (!containedIndexes.length) return;

  const referenceIndex = backwards
    ? Math.min(...containedIndexes)
    : Math.max(...containedIndexes);
  const target = focusableElements[referenceIndex + (backwards ? -1 : 1)];

  if (target) {
    window.setTimeout(() => target.focus(), 0);
  }
};
